export default "__VITE_ASSET__D5OOHcBM__"